import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PopupPropsContext } from "@progress/kendo-react-popup";
import { Tooltip } from "@progress/kendo-react-tooltip";
import RelationList from "../../components/OverallSearch/RelationList";
import { getRelationData, openSidebar } from "../../components/Tasks/tasks.service";
import { icon, label } from "../../config";
import { usePopup } from "../../helper/commonHooks";
import { formatDate } from "../editor.helper";
import TaskDetailsContent from "./TaskDetailsContent";
import TaskIcons from "./TaskIcons";
import "./taskDetail.scss";

/**
 * Non Editable Editor
 * PC KendoEditor
 * @author Shivam Mishra
 */
const TaskDetails = ({ taskInfo, hashPopupVisible, url, copyToClipboard, setHashPopupVisible }) => {
  const { Name, ProjectTaskId, Priority, Assignee, DueDate, IsTaskComplete } = taskInfo;
  const { show, setShow, anchor, contentRef, blurTimeoutRef, onOpen, onFocus, onBlur } = usePopup();
  const dispatch = useDispatch();
  const [showPopup, setShowPopup] = useState(false);

  const { task } = useSelector((state) => state.taskSidebar);
  const { assigneeList } = useSelector((state) => state.tasks.defaultDetails);
  const userInfo = assigneeList?.find((user) => user.value === Assignee);
  /**
   * load link task relation list.
   * @call {*} getLinkTasks
   */
  useEffect(() => {
    (async () => {
      await dispatch(getRelationData());
    })();
  }, []);

   /**
   * Handles opening the sidebar and hiding the hash popup
   * @author Sejal Bansal
   */
   const handleOpenSidebar = () => {
    openSidebar({ id: taskInfo?.Id });
    setHashPopupVisible(false);
  };

  /**
   * Handles opening the mediation popup
   * @author Sejal Bansal
   */
  const handleMediationClick = () => {
    setShowPopup(true);
    setShow(true);
  };

  return (
    <>
      {hashPopupVisible ? (
        <div className='details-popup-minwidth task-tile-container w-100'>
          <div className='task-details-container mb-2 pb-2 border-bottom'>
            <Tooltip parentTitle={true} position='bottom'>
              <span className='cursor-default task-name-container d-flex w-100'>
                 <span className='task-details-id fw-bold'>{label.TASK} </span>
              </span>
            </Tooltip>
            <div className='d-flex align-items-center justify-content-center ml-2'>
              <TaskIcons // Task Icons
                url={url}
                taskInfo={taskInfo}
                copyToClipboard={copyToClipboard}
                anchor={anchor}
                setShow={setShow}
                setShowPopup={setShowPopup}
                setHashPopupVisible={setHashPopupVisible}
              />
            </div>
          </div>
          <TaskDetailsContent taskInfo={taskInfo} userInfo={userInfo} handleOpenSidebar={handleOpenSidebar}  hashPopupVisible={hashPopupVisible} />
        </div>
      ) : (
        <div className='row '>
          {task.taskId && (
            <Tooltip position='bottom' parentTitle={true}>
            <div title='Link This Task'
              className='editor-popup-task-icon-position position-absolute cursor-pointer  task-icons-link editor-popup-task-icon'
              ref={anchor}
              onClick={handleMediationClick}>
              {icon.MEDIATION}
            </div>
            </Tooltip>
          )}
          <div className='col-md-12'>
            <div className='container pt-2  pb-2 details-popup-minwidth task-tile-container w-100 '>
            <TaskDetailsContent taskInfo={taskInfo} userInfo={userInfo} handleOpenSidebar={handleOpenSidebar}  hashPopupVisible={hashPopupVisible} />
         </div>
          </div>
        </div>
      )}
      {showPopup && (
        <PopupPropsContext.Provider
          value={(props) => ({
            ...props,
            appendTo: anchor.current,
          })}>
          <RelationList
            anchor={anchor}
            hashPopupVisible={hashPopupVisible}
            show={show}
            setShowPopup={setShowPopup}
            selectedItem={taskInfo}
            relationListRef={contentRef}
            blurTimeoutRef={blurTimeoutRef}
            onOpen={onOpen}
            onFocus={onFocus}
            onBlur={onBlur}
            setShow={setShow}
          />
        </PopupPropsContext.Provider>
      )}
    </>
  );
};

export default React.memo(TaskDetails);
